import { z } from 'zod';
export const leadStatusCategorySchema = z.enum(['open', 'qualified', 'converted', 'lost', 'disqualified']);
export const createLeadStatusSchema = z.object({
    name: z.string().trim().min(1).max(60),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/),
    category: leadStatusCategorySchema,
    isDefault: z.boolean().default(false),
    countsAsQualified: z.boolean().default(false),
});
export const updateLeadStatusSchema = createLeadStatusSchema.partial().extend({
    position: z.number().int().optional(),
});
export const reorderSchema = z.object({ orderedIds: z.array(z.string().uuid()).min(1) });
export const leadStatusResponseSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    color: z.string(),
    category: leadStatusCategorySchema,
    position: z.number().int(),
    isDefault: z.boolean(),
    isSystem: z.boolean(),
    countsAsQualified: z.boolean(),
    usageCount: z.number().int(),
});
export const createLeadSourceSchema = z.object({
    name: z.string().trim().min(1).max(100),
    channel: z.string().trim().max(50).optional(),
    isActive: z.boolean().default(true),
});
export const updateLeadSourceSchema = createLeadSourceSchema.partial();
export const leadSourceResponseSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    channel: z.string().nullable(),
    isActive: z.boolean(),
    usageCount: z.number().int(),
});
//# sourceMappingURL=lead-config.js.map